import { Navigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useWarpMerchant } from 'common/hooks/useWarpMerchant';
import { useWarpMerchantsForUser } from 'common/hooks/useWarpMerchantsForUser';

import { getTenantConfig } from '../../config/tenantConfig';

export const MerchantRedirect = () => {
  const { getMerchant, setMerchant } = useWarpMerchant();
  const { data: merchants } = useWarpMerchantsForUser();
  const merchant = getMerchant();

  const shouldAutoSetMerchant = merchants?.length === 1 && !merchant;

  useEffect(() => {
    if (shouldAutoSetMerchant) {
      setMerchant(merchants[0]);
    }
  }, [merchants, shouldAutoSetMerchant, setMerchant]);

  if (!merchant) {
    return <Navigate to="/merchant-selection" />;
  }

  const { landingRoute } = getTenantConfig(merchant.id);

  return <Navigate to={`/${landingRoute}`} />;
};
